import React, { Component } from 'react'
import { connect } from 'react-redux'
import './style.scss'

import { changeLanguageEN, changeLanguageES, changeLanguagePORT } from '../../../index'

const Translate = require('react-redux-i18n').Translate

const mapDispatchToProps = dispatch => ({
  changeLangEN() {
    changeLanguageEN()
  },
  changeLangES() {
    changeLanguageES()
  },
  changeLangPORT() {
    changeLanguagePORT()
  },
})

@connect(mapDispatchToProps)
class Languaje extends Component {
  state = {
    className: 'selectEspañol',
  }

  changeLangEnglish = () => {
    this.props.changeLangEN()
    this.setState({
      className: 'selectIngles',
    })
  }
  changeLangEspanish = () => {
    this.props.changeLangES()
    this.setState({
      className: 'selectEspañol',
    })
  }

  changeLangPortugues = () => {
    this.props.changeLangPORT()
    this.setState({
      className: 'selectPortugues',
    })
  }
  render() {
    return (
      <div className="col-12 selectLanguaje" align="right">
        <a onClick={this.changeLangEnglish}>
          <span role="img" aria-label="bandera">
            🇬🇧
          </span>
          <Translate value="application.Ingles" />
          &nbsp;&nbsp;&nbsp;
        </a>
        <a onClick={this.changeLangEspanish}>
          {' '}
          &nbsp;&nbsp; 🇨🇴
          <Translate value="application.Español" />
          &nbsp;&nbsp;&nbsp;
        </a>
        <a onClick={this.changeLangPortugues}>
          {' '}
          &nbsp;&nbsp; 🇧🇷
          <Translate value="application.portugues" />
          &nbsp;&nbsp;&nbsp;
        </a>
        {/* //  className={this.state.className} */}
        <div />
      </div>
    )
  }
}

export default Languaje



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/languaje.js